<template>
  <div>
    <template v-for="(a, index) in optionsFiltered">
      <button
        :key="index"
        type="button"
        class="btn btn-default btn-small"
        :class="{ 'btn-brand': hasBrand(a) }"
        :disabled="busy"
        @click.prevent="triggerAction(a, subscriptionTemplateId, productOption.uniqueSubscriptionId)"
      >
        {{ $to(buttonText(a)) }}
      </button>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import StockProxy from '@/proxies/SubstoreStockProxy';
import {
  STOCK_PRODUCT_CHANGE_SELECTION,
  PRODUCT_ORDER_FINALIZE,
  PRODUCT_ORDER_SUMMARY_OPTIN,
  PRODUCT_ADMINISTRATION_SELECTION,
  PRODUCT_ORDER_SELECTION,
} from '@route-types';

export default {
  name: 'StockProductButton',

  inheritAttrs: false,

  props: {
    id: {
      type: String,
      required: true,
    },

    subscriptionTemplateId: {
      type: String,
      required: true,
    },

    options: {
      type: Array,
      required: true,
    },

    productOption: {
      type: Object,
      required: true,
    },

    texts: {
      type: Object,
      required: true,
    },

    onlyNotTerminated: {
      type: Boolean,
      required: false,
    },
  },

  data() {
    return {
      STOCK_PRODUCT_CHANGE_SELECTION,

      busy: false,
      textMapping: {
        cancel: this.texts.orderCancellationButtonLabel,
        termination: this.texts.orderTerminationButtonLabel,
        reservationDeletion: this.texts.orderReservationDeletionButtonLabel,
        reservationTermination: this.texts.orderReservationDeletionButtonLabel,
        reactivation: this.texts.orderReactivationButtonLabel,
        productChange: this.texts.productChangeButtonLabel,
        finalize: this.texts.orderFinalisationButtonLabel,
        administration: this.texts.orderAdministrationButtonLabel,
        resume: this.texts.orderReservationFinalisationButtonLabel,
        optin: this.texts.orderOptinButtonLabel,
      },
      routedActions: {
        productChange: STOCK_PRODUCT_CHANGE_SELECTION,
        resume: PRODUCT_ORDER_SELECTION,
        optin: PRODUCT_ORDER_SUMMARY_OPTIN,
        administration: PRODUCT_ADMINISTRATION_SELECTION,
        finalize: PRODUCT_ORDER_FINALIZE,
      },
    };
  },

  computed: {
    ...mapState('system', ['features']),

    optionsFiltered() {
      return this.options.filter(o => this.productOption[`${o}Allowed`] && (!this.onlyNotTerminated || !this.productOption.isTerminated));
    },
  },

  methods: {
    hasBrand(action) {
      return action === 'resume';
    },

    async routeAction(name, subscriptionTemplateId, uniqueSubscriptionId) {
      await this.$store.dispatch('contract/change', { uniqueSubscriptionId });

      let params = { subscriptionTemplateId, uniqueSubscriptionId };
      if (name === 'optin') {
        params = {
          subscriptionTemplateId,
          orderCallId: (await new StockProxy().stockAction(subscriptionTemplateId, uniqueSubscriptionId, name)).data.orderCallId,
        };
      }
      if (name === 'finalize') {
        params = { subscriptionTemplateId };
      }
      this.$router.push({
        name: this.routedActions[name],
        params,
      });
    },

    async triggerAction(name, subscriptionTemplateId, uniqueSubscriptionId) {
      this.busy = true;

      try {
        if (this.routedActions[name]) {
          await this.routeAction(name, subscriptionTemplateId, uniqueSubscriptionId);
        } else {
          this.$emit('update:action', {
            name,
            headline: this.buttonText(name),
            id: this.id,
            subscriptionTemplateId,
            uniqueSubscriptionId,
          });
        }
      } finally {
        this.busy = false;
      }
    },

    buttonText(action) {
      if (this.textMapping[action]) return this.textMapping[action];
      return `substore.btn_${action}`;
    },
  },
};
</script>
